// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingIndicator_wrapper__pRCmJ","loaderContainer":"LoadingIndicator_loaderContainer__igpvR"};